import axios from "axios";

const url = "https://scuffedwebsite.com/Tsunami/api";

/**
 * Going to leave the shorthand as standard and the verbose as comments
 */

/**
 * 
 * @param {String} quality
 * As of now either mp3 or native depending on quality choice
 * @returns {Object[]}
 */

export const fetchPosts = async (quality) => await axios.get(`${url}/${quality}`);

/* export const fetchPosts = async (quality) =>
{
  return await axios.get(`${url}/${quality}`);
} */

